import timestring from 'timestring';
import { z } from 'zod';
import { trackError } from '#api/errors.ts';

export const INVALID_ERR = 'Please input a duration in seconds';
export const LESS_THAN_ONE_SECOND = 'Please provide a duration larger than zero seconds';
export const MORE_THAN_TWO_DAYS = 'Please provide a duration shorter than 172,800 seconds';

/**
 * Schema for a duration string.
 * Should be used in concert with mapStringToDurationOrOriginal
 */
export const durationSchema = z
  .string()
  .trim()
  .transform((arg, ctx) => {
    if (/^[0-9]+$/.test(arg)) {
      return `${arg}s` as `${number}s`;
    }
    if (/^[0-9]+s$/.test(arg)) {
      return arg as `${number}s`;
    }
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: INVALID_ERR,
      fatal: true,
    });
    return z.NEVER;
  })
  .superRefine((value, ctx) => {
    try {
      const seconds = timestring(value);
      if (seconds < 1) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: LESS_THAN_ONE_SECOND,
          fatal: true,
        });
        return z.NEVER;
      }
      if (seconds > 2 * 24 * 60 * 60) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: MORE_THAN_TWO_DAYS,
          fatal: true,
        });
        return z.NEVER;
      }
    } catch (e) {
      if (
        e instanceof Error &&
        // ignore timestring errors
        (new RegExp(/The unit \[.{0,255}\] is not supported by timestring/).test(e.message) ||
          new RegExp(/The string \[.{0,255}\] could not be parsed by timestring/).test(e.message))
      ) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: INVALID_ERR,
          fatal: true,
        });
        return z.NEVER;
      }
      trackError(e);
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: INVALID_ERR,
        fatal: true,
      });
      return z.NEVER;
    }
  })
  .nullable()
  .or(z.literal(''));
